import {Pipe, PipeTransform} from "@angular/core";
import {Participant, SimUser} from "@models";

@Pipe({
	name: "transformParticipantsToSimUsers",
	standalone: true,
})
export class TransformParticipantsToSimUsersPipe implements PipeTransform {
	transform(participations: Participant[]): SimUser[] {
		const newUsers = participations.map((value) => value.user);
		return newUsers;
	}
}
